const icon1 = require("../assets/images/list/icon1.png")
const icon2 = require("../assets/images/list/icon2.png")
const icon3 = require("../assets/images/list/icon3.png")
const icon4 = require("../assets/images/list/icon4.png")
const icon5 = require("../assets/images/list/icon5.png")
const icon7 = require("../assets/images/list/icon7.png")
// 远程定责
export const commonData = [
  { name: 'todayTelephone', todayTelephone: '保险案数', icon: icon1 },
  // { name: 'talkTime', talkTime: '接电时长', icon: icon2 },
  { name: 'liability', liability: '已定责', icon: icon2 },
  { name: 'liabilityNo', liabilityNo: '待定责', icon: icon3 },
  { name: 'claim', claim: '已理赔', icon: icon3 },
  { name: 'claimNo', claimNo: '待理赔', icon: icon4 },
  { name: 'claimAmount', claimAmount: '理赔金额', icon: icon2 }
];
// 保险和一件救援
export const InsuranceData = [
  { name: 'todayTelephone', todayTelephone: '保险案数', icon: icon1 },
  // { name: 'talkTime', talkTime: '接电时长', icon: icon2 },
  { name: 'rescueTypeNum', rescueTypeNum: '维修二维码', icon: icon7 },
  { name: 'directIndemnityTypeNum', directIndemnityTypeNum: '人伤二维码', icon: icon5 },
  { name: 'claim', claim: '人伤理赔', icon: icon3 },
  { name: 'claimNo', claimNo: '调解数', icon: icon4 },
  { name: 'claimAmount', claimAmount: '理赔金额', icon: icon2 }
];
// 医院,拖修车
export const hospitalData = [
  { name: 'totalNum', totalNum: '今日新增', icon: icon3 },
  { name: 'settled', settled: '已结清', icon: icon7 },
  { name: 'nonSettled', nonSettled: '未结清', icon: icon4 },
  { name: 'totalCost', totalCost: '费用总计', icon: icon2 }
];
